import type { FC } from 'react';

import { ButtonGroup, CircularProgress, IconButton, Stack, Tooltip, Typography } from '@mui/material';

import CloseIcon from 'components/icons/Close';
import RefreshIcon from 'components/icons/Refresh';

export interface ProjectHistoryPanelHeaderProps {
  onClose: () => void;
  onRefreshProjectHistory: () => void;
  isFetching: boolean;
}

export const ProjectHistoryPanelHeader: FC<ProjectHistoryPanelHeaderProps> = ({
  onClose,
  isFetching,
  onRefreshProjectHistory
}) => {
  return (
    <Stack direction='row' justifyContent='space-between' alignItems='center' height='32px'>
      <Typography variant='subtitle1'>History</Typography>

      <ButtonGroup sx={{ alignItems: 'center' }}>
        {isFetching ? (
          <CircularProgress size={20} sx={(theme) => ({ color: theme.palette.grey['A700'] })} />
        ) : (
          <Tooltip title='Refresh' placement='bottom'>
            <IconButton onClick={onRefreshProjectHistory} sx={{ ml: '8px' }}>
              <RefreshIcon />
            </IconButton>
          </Tooltip>
        )}

        <IconButton onClick={onClose} sx={{ ml: '8px' }}>
          <CloseIcon />
        </IconButton>
      </ButtonGroup>
    </Stack>
  );
};
